import React, { createContext, useState } from 'react';

export const DateRangeContext = createContext();

export const DateRangeProvider = ({ children }) => {
    const [dateRange, setDateRange] = useState('all');
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');

    return (
        <DateRangeContext.Provider value={{ dateRange, setDateRange, customStartDate, setCustomStartDate, customEndDate, setCustomEndDate }}>
            {children}
        </DateRangeContext.Provider>
    );
};